import { motion } from "framer-motion";

interface StepIndicatorProps {
  currentStep: 1 | 2 | 3;
}

const steps = [
  { number: 1, label: "Contato" },
  { number: 2, label: "Empresa" },
  { number: 3, label: "Agenda" },
];

const StepIndicator = ({ currentStep }: StepIndicatorProps) => {
  return (
    <div className="flex items-center justify-center w-full py-8">
      {steps.map((step, index) => (
        <div key={step.number} className="flex items-center">
          {/* Step circle */}
          <div className="flex flex-col items-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: index * 0.1 }}
              className={`relative flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                step.number < currentStep
                  ? "bg-primary border-primary"
                  : step.number === currentStep
                  ? "border-primary bg-background"
                  : "border-muted-foreground/30 bg-background"
              }`}
            >
              {step.number < currentStep ? (
                <motion.svg
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="w-5 h-5 text-primary-foreground"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </motion.svg>
              ) : (
                <span
                  className={`text-sm font-semibold ${
                    step.number === currentStep
                      ? "text-primary"
                      : "text-muted-foreground/50"
                  }`}
                >
                  {step.number}
                </span>
              )}
            </motion.div>
            <span
              className={`mt-2 text-xs font-medium transition-colors ${
                step.number <= currentStep
                  ? "text-foreground"
                  : "text-muted-foreground/50"
              }`}
            >
              {step.label}
            </span>
          </div>

          {/* Connector line */}
          {index < steps.length - 1 && (
            <div className="relative w-16 sm:w-24 h-0.5 mx-2 bg-muted-foreground/20 overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                animate={{
                  width: step.number < currentStep ? "100%" : "0%",
                }}
                transition={{ duration: 0.3, delay: 0.1 }}
                className="absolute inset-0 bg-primary"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
